import find from 'lodash/find';

import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useDeviceEdit = ({ calendars, onSuccess }) => {
  const { onSubmit: handleEdit } = useFetch('device-rename', Api.DEVICE_EDIT);

  const onEdit = (device) => (values) => {
    let body = Object.assign({}, device);

    if (values.calendar) {
      const calendar = find(calendars, ({ id }) => id === values.calendar);
      body = Object.assign({}, body, { calendar: calendar || {} });
    } else {
      body = Object.assign({}, body, values);
    }

    const { name, timezone, calendar = {} } = body;

    handleEdit({
      body: {
        name: name,
        calendarId: calendar.id,
        timezone,
      },
      pathParams: { id: device.id },
      onSuccess,
    });
  };

  return {
    onEdit,
  };
};

export default useDeviceEdit;
